var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-tag",class:[
        _vm.type ? 'app-tag--' + _vm.type : '',
        _vm.tagSize ? 'app-tag--' + _vm.tagSize : '',
        _vm.closable ? 'closable' : ''
    ]},[(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e(),(_vm.closable)?_c('div',{staticClass:"app-tag--action",on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"icon icon-close"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }